import AtendimentosCobranca from "../Atendimentos";

export default function GrupoAtendimentosCobranca() {
    return <AtendimentosCobranca atendimento={"GRUPO"} />;
}
